/*global define:false*/
define('addFolderViewConfig',['addFolderViewModel'], function (addFolderViewModel) {
    'use strict';

    return {
        name : 'addFolderView',
        ModelType : addFolderViewModel,
        modelData : {},
        listeners : [],
        events : {},
        permissions : ['admin', 'editor']
    };
});

